import validate from 'validate.js';


export const urlValidationRule = {
    url: {
        url: {
            message: '^Provide a valid domain',
        },
    },
};

export function extractDomainAndHomepage(inputDomain: string): { domain: string | null, homepage: string | null, error: string | null } {
    let error = null;
    let domain = null;
    let homepage = null;

    try {
        domain = inputDomain
            .trim()
            .toLowerCase()
            .replaceAll("https://", "")
            .replaceAll("http://", "")
            .split("/")[0]
            .split(":")[0]
            .split("?")[0];
        if (domain.startsWith("www.")) {
            domain = domain.substring(4);
        }

        if (!/([a-z0-9|-]+\.)*[a-z0-9|-]+\.[a-z]+/.test(domain)) {
            throw new Error("Invalid domain");
        }

        homepage = `https://${domain}`;
        const urlObject = new URL(homepage);

        if (urlObject.hostname !== domain) {
            throw new Error("Invalid domain");
        }
    } catch (err) {
        error = "Invalid domain";
    }
    return { domain, homepage, error };
}

export function validateUrl(url: string, domain: string): string {
    let urlValidationError = validate({ url: url }, urlValidationRule);

    if (urlValidationError) {
        return urlValidationError.url[0];
    }

    const urlObject = new URL(url);

    const strippedDomain = domain
        ?.replace('https://', '')
        .replace('http://', '')
        .replace(/^www\./, '');
    const strippedUrlObjectDomain = urlObject.hostname.replace(/^www\./, '');

    if (strippedDomain !== strippedUrlObjectDomain) {
        return 'URL does not match the domain';
    }

    return '';
}


export function validateInputUrls(inputUrls: string, domain: string) {
    const parseUrls = (txt: string) => {
        return txt
            .split(/\r\n|\r|\n/)
            .map(url => url.trim())
            .filter(url => url !== "");
    };

    let urls: string[] = [];
    inputUrls.split(',').forEach((txt) => {
        urls = [...urls, ...parseUrls(txt)];
    });

    let validationErrors = urls.map((url) => validateUrl(url, domain));

    if (urls.length === 0) {
        validationErrors = ['Please enter at least one URL'];
    }

    return [urls, validationErrors];
}

export function getUrlStringFromObjectEntries(object: Object): string {
    let string = '';

    Object.entries(object).forEach(([key, value], index) => {
        if (index !== 0) {
            string = string.concat(',');
        }
        string = string.concat(`${key}=${value}`);
    });

    return encodeURIComponent(string);
}
